import React, { FC, ReactNode, useState, useEffect } from 'react'
/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Transition, TransitionGroup } from 'react-transition-group'
import { FastCoverageIcon, CloseIcon } from '@components/Icons'
import { Button } from '@components/Button'
import { TimeRemaining } from '@components/TimeRemaining'
import { DesktopOnly } from '@components/MediaQuery'
import {
  ApptBannerWrapper,
  InnerWrapper,
  MessageWrapper,
  IconWrapper,
  CloseBtnWrapper,
  ScheduleBtnTextMobile,
  ScheduleBtnTextDesktop,
  TimeRemainingWrapper,
  TimeRemainingMobileWrapper,
  closeButtonStyles,
  scheduleButtonStyles,
  TRANSITION_DELAY
} from './ApptBanner.elements'

type Props = {
  message?: string
  icon?: ReactNode
  initiateOpen?: boolean
  onSchedule: () => void
  includeTimer: boolean
}

export const ApptBanner: FC<Props> = ({
  message = <span>Save up to 43% on Medicare Supplement Insurance</span>,
  icon = <FastCoverageIcon />,
  initiateOpen,
  onSchedule,
  includeTimer
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(!!initiateOpen)
  const [isActive, setIsActive] = useState<boolean>(true)

  useEffect(() => {
    setIsOpen(true)
  }, [])

  const handleClose = () => {
    setIsOpen(false)
  }
  const handleHideContent = () => {
    setIsActive(false)
  }

  const endDate = new Date(2020, 11, 8) // Dec 7, 2020. # TODO: why doesn't the timer show the right number of days?
  const now = new Date()

  //enable for any new countdown
/*  if (!isActive || now >= endDate) {
    return null
  }*/

  return (
    <TransitionGroup>
      {isOpen && (
        <Transition
          key="info-banner"
          in={!initiateOpen}
          appear={!initiateOpen}
          timeout={TRANSITION_DELAY}
        >
          {state => (
            <ApptBannerWrapper state={state} includeTimer={includeTimer}>
              <InnerWrapper includeTimer={includeTimer} state={state}>
                <MessageWrapper includeTimer={includeTimer}>
                  { includeTimer &&
                    <IconWrapper>
                      {icon}
                    </IconWrapper>
                  }
                  {message}
                  { includeTimer &&
                    <>
                      <DesktopOnly>
                        <TimeRemainingWrapper>
                          <TimeRemaining
                            endDate={endDate}
                            onFinish={handleHideContent}
                          />
                        </TimeRemainingWrapper>
                      </DesktopOnly>
                      <TimeRemainingMobileWrapper>
                        <TimeRemaining
                          endDate={endDate}
                          onFinish={handleHideContent}
                        />
                      </TimeRemainingMobileWrapper>
                    </>
                  }
                  <Button
                    onClick={onSchedule}
                    variant="link-white"
                    css={scheduleButtonStyles}
                  >
                    <ScheduleBtnTextMobile>
                      SCHEDULE TODAY
                    </ScheduleBtnTextMobile>
                    <ScheduleBtnTextDesktop>
                      SCHEDULE MY PERSONAL CONSULTATION
                    </ScheduleBtnTextDesktop>
                  </Button>
                </MessageWrapper>

              </InnerWrapper>

              <CloseBtnWrapper>
                <Button
                  onClick={handleClose}
                  circled
                  css={closeButtonStyles}
                  aria-label="Close info banner"
                >
                  <CloseIcon />
                </Button>
              </CloseBtnWrapper>
            </ApptBannerWrapper>
          )}
        </Transition>
      )}
    </TransitionGroup>
  )
}
